module.exports = __webpack_public_path__ + "static/media/nfc-orange-pay.f28df4c7.png";